<template>
  <div class="stepper-container">
    <div class="stepper-wrapper">
      <!--  -->
      <div class="progress" :style="{ width: progressWidth }"></div>

      <div v-for="(step, i) in steps" :key="i">
        <p
          class="caption"
          :class="{
            completed: activeStep >= i + 1,
            first: i == 0,
            last: i == steps.length - 1
          }"
        >
          {{ step }}
        </p>

        <div
          class="screen-indicator"
          :class="{
            completed: activeStep >= i + 1,
            active: activeStep === i + 1 && activeStep != 1,
            last: i == steps.length - 1
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Stepper',

  data: () => ({
    activeStep: 1
  }),

  computed: {
    isSalesForceConnected() {
      return this.$store.getters['integration/isSalesForceConnected']
    },

    progressWidth() {
      if (this.isSalesForceConnected) {
        return this.stepPlusSalesForce
      } else {
        return this.StepsMinusSalesForce
      }
    },
    StepsMinusSalesForce() {
      switch (this.activeStep) {
        case 1:
          return '0%'
        case 2:
          return '24%'
        case 3:
          return '49%'
        case 4:
          return '70%'
        case 5:
          return '99%'
        default:
          return '0%'
      }
    },
    stepPlusSalesForce() {
      switch (this.activeStep) {
        case 1:
          return '0%'
        case 2:
          return '18%'
        case 3:
          return '37%'
        case 4:
          return '52%'
        case 5:
          return '70%'
        case 6:
          return '86%'
        default:
          return '0%'
      }
    },
    steps() {
      const steps = [
        'Shopping Bag',
        'Shipping',
        'Add a Card',
        'Review Order',
        'Confirmation'
      ]
      if (this.isSalesForceConnected) {
        steps.splice(3, 0, 'Link Salesforce')
      }
      return steps
    }
  },

  mounted() {
    this.activeStep = this.$route.meta && this.$route.meta.step
  },

  methods: {
    next() {
      // check to see if we are on the last step
      if (this.activeStep === this.steps.length) {
        return
      } else {
        this.activeStep++
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.stepper-container {
  text-align: center;
}
.stepper-wrapper {
  margin: 30px auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  .caption {
    font-family: $inter;
    font-size: 0.688rem;
    color: #979797;
    font-weight: 300;
    padding-bottom: 1.25rem;
    text-align: left;
    position: relative;
    right: 30px;
    /* min-width: 103px; */

    &.first,
    &.last {
      right: 0px;
    }

    &.completed {
      color: $main-6;
    }
  }
}

.stepper-wrapper::before {
  content: '';
  width: 99%;
  height: 1.4px;
  background-color: #a09c95;
  border-radius: 10px;
  position: absolute;
  z-index: -2;
  bottom: 4px;
}

.progress {
  content: '';
  width: 0%;
  height: 2px;
  background-color: $main-6;
  border-radius: 10px;
  position: absolute;
  z-index: -1;
  bottom: 4px;
  transition: width 1s;
}

.screen-indicator {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid rgba(151, 151, 151, 0.3);
  background-color: inherit;
  /* padding: 10px 13px; */
  /* color: gray; */
  transition: border-color color;
  transition-duration: 0.7s;
  background: $main-white;

  &.completed {
    border-color: $main-6;
    background: $main-6;
  }

  &.last {
    position: relative;
    left: 50px;
  }
}

.active {
  border-radius: 60px;
  transform: scale(1);
  animation: pulse-holder 3s none;
  animation-delay: 300ms;
  /* animation-iteration-count: 1; */
}

@keyframes pulse-holder {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
  }

  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
  }

  100% {
    transform: scale(0.95);
    box-shadow: rgba(5, 242, 154, 0.1);
  }
}
</style>
